/**
 * @file `GET /me/families` のクライアント。
 * @what: caller が active member として属する Family の一覧を取得する。
 * @why: いちごスタディの家族選択 (epic_23)。app の「アクティブ家族」store は
 *   web に無いので、一覧から選ばせる。
 */

import { apiFetch } from "@/shared/api/client";

export interface MyFamily {
  family_id: string;
  role: string;
  status: string;
  joined_at?: string;
  display_name?: string;
}

interface MyFamiliesResponse {
  families: MyFamily[];
}

export async function fetchMyFamilies(signal?: AbortSignal): Promise<MyFamily[]> {
  const res = await apiFetch<MyFamiliesResponse>("/me/families", signal ? { signal } : {});
  return res.families;
}

/** 表示名が無い Family の既定ラベル。 */
export function familyLabel(family: MyFamily): string {
  if (family.display_name && family.display_name.length > 0) {
    return family.display_name;
  }
  // 家族名が未設定のときに id を出すと画面が識別子だらけになる (代表 2026-08-24)。
  // どの家族かはメニューを開けば役割とアカウント名で分かるので、既定は素の呼び名にする。
  return "わが家";
}

/** role 呼称は app の UI 辞書 (app_localizations_ja.dart) と揃える。 */
const ROLE_LABELS: Record<string, string> = {
  parent: "親",
  grandparent: "祖父母",
  relative: "親族",
  guardian: "保護者",
  caregiver: "養育者",
  child: "子",
};

export function roleLabel(role: string): string {
  return ROLE_LABELS[role] ?? role;
}
